<template>
  <div class="father">
    <div class="register">
      <div class="title" style="">用户注册</div>

      <el-form label-width="100px">
        <el-form-item label="性别 ：" clearable>
          <!-- <el-input v-model="register_data.sex"></el-input> -->
          <template>
            <el-radio v-model="register_data.sex" label="0">男</el-radio>
            <el-radio v-model="register_data.sex" label="1">女</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="姓名 ：" clearable>
          <el-input v-model="register_data.account_name" clearable></el-input>
        </el-form-item>

        <el-form-item label="账号 ：" clearable>
          <el-input v-model="register_data.account_no" clearable></el-input>
        </el-form-item>

        <el-form-item label="密码 ：" clearable>
          <el-input v-model="register_data.pass_word" show-password></el-input>
        </el-form-item>
        <el-form-item label="手机号 ：" clearable>
          <el-input v-model="register_data.mobile_no" clearable></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          
          <div class="item-input" style="display:flex">
            <el-input
              type="text"
              placeholder="输入短信验证码："
              :disabled="!register_data.mobile_no"
              style="padding:0 ;"
              v-model="register_data.verify_code"
            />
            <span
              style="font-weight: 700;width: 200px;text-align: center;cursor: pointer;"
              :style="[
                {
                  color:
                    !register_data.mobile_no ||
                    (timmer != null && register_data.mobile_no)
                      ? '#ccc'
                      : 'royalblue'
                }
              ]"
              @click="getMsg"
              >{{ msg_str }}</span>
            
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="register"> 会员注册</el-button>
          <el-button @click="goBack"> 返回 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getEnvironment } from "../js/public";
import { accountRegister,sendMsg } from "@/api/login";
export default {
  data() {
    return {
      environment: "",
      register_data: {
        account_no: "",
        account_name: "",
        sex: "0",
        pass_word: "",
        mobile_no: "",
        verify_code: ""
      },
      timmer:null,
      msg_str:"发送验证码"
    };
  },
  mounted() {
    this.environment = getEnvironment();
    if (this.environment == "alipay") {
    } else if (this.environment == "micromessenger") {
    } else if (this.environment == "h5") {
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    async getMsg(){
      const that = this;
				if (this.register_data.mobile_no == "") {
					this.warnMessage("请输入手机号！");
				}
				if (this.timmer != null) {
					this.warnMessage("请稍后重试！");
				} else {
					const res = await sendMsg(this.register_data.mobile_no);
					if (this.testR(res)) {
						this.successMessage(res.data.resp_data);
						var time = 180;
						this.timmer = setInterval(() => {
							that.msg_str = `${time}秒后重新发送`;
							time--;
							if (time < 1) {
								clearInterval(that.timmer);
								that.timmer = null;
								that.msg_str = `发送验证码`;
							}
						}, 1000);
					}

				}
    },
    //TODO: Rsa公钥获取
    async register() {
      // this.successMessage("成功");
      /* try {
        var { data: result } = await this.$Rsa.getKey(
          "https://test-api.hakspay.cn/v1/ePlatform/Service/common/getsyskey"
        );
      } catch (e) {
        this.$message.error({
          message:e
        })
      } */
      
      var obj = {
        account_no: this.register_data.account_no,
        account_name: this.register_data.account_name,
        sex: this.register_data.sex,
        verify_code:this.register_data.verify_code,
        mobile_no: await this.$encrypt(
          this.register_data.mobile_no,
          "mobile_no"
        ),
        pass_word: await this.$encrypt(
          this.register_data.pass_word,
          "pass_word"
        )
      };
      try {
        const res = await accountRegister(obj);
        if (this.testR(res)) {
          this.successMessage(res.data.resp_data);
          this.goBack();
        }
      } catch (e) {
        this.$message.error({
          message: e
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.father {
  justify-content: center;
  align-items: center;
  background: url(../assets/pic/0001.jpg);
  background-position: center;
  background-attachment: fixed;
  background-size: 105% auto;
  .register {
    max-width: 600px;
    width: 94%;
    height: auto;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    color: #000 !important;
    padding: 20px 20px 30px;
    margin-top: -100px;
    .title {
      width: 100%;
      text-align: center;
      font-size: 24px;
      padding: 10px;
      margin: 10px;
      color: #242424;
      font-weight: 700;
    }
  }
  /* .el-form {
    .el-form-item {
      /deep/ * {
        font-size: 18px;
        color: #000;
      }
    }
  } */
  /* .el-form {
    .el-input {
      /deep/ * {
        font-size: 18px;
        color: #000;
      }
    }
  } */
}
</style>
